import React from "react";
import { Component, Children } from "react";

export const I18nContext = React.createContext();

export default class I18nProvider extends Component {
  render() {
    return (
      <I18nContext.Provider
        value={{
          i18n: this.props.i18n,
          lang: this.props.lang,
          interpolate: this.props.interpolate,
          setLangFlag: this.props.setLangFlag
        }}
      >
        {Children.only(this.props.children)}
      </I18nContext.Provider>
    );
  }
}
